<template>
  <div class="techs-container" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <div class="left-sidebar">
      <div class="left-sidebar__header">
        <img src="/static/img/pictos/technicien.svg" class="">
        <span>Mes Techniciens</span>
      </div>
    </div>
    <div class="content-area">
      <backlink/>
      <div class="filters">
        <input class="filter" type="text" name="" placeholder="Rechercher par nom">
        <input class="filter" type="text" name="" placeholder="Rechercher par véhicule">
      </div>
      <div class="techs">
        <div class="techs__tech tech" v-for="item in items" :key="item.id">
          <div class="tech__info-container">
            <h3 class="tech__name">{{ item.technician.firstname}} {{ item.technician.lastname}}</h3>
            <div class="tech__stock-container">
              <p class="tech__stock stock">Valeur du stock : <span class="stock__number">{{ item.total_amount_vehicle }} €</span></p>
            </div>
          </div>
          <div class="tech__btns">
            <router-link
              v-if="item.technician.id"
              :to="{name: 'TechDetail', params: {id:item.technician.id}}"
              class="tech__btn-container"
            >
              <span>Voir le détail</span>
              <a class="tech__btn">
                <img src="/static/img/pictos/flecheblanche.svg">
              </a>
            </router-link>
            <!-- Voir le détail
            <a href="" class="tech__btn tech__btn--see"><img src="/static/img/pictos/flecheblanche.svg" alt="" class="fleche"></a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "TechList",
  data() {
    return {

    };
  },
  computed: {
    items: function() {
      let myTechs = this.$store.getters["auth/myTechs"];
      if(typeof(myTechs) == 'string'){
        return JSON.parse(myTechs)
      }else{
        return myTechs;
      }
    }
  },
  mounted() {
    this.$store.dispatch("auth/getMyTechs");
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .techs-container{ display: flex;

  }
  .left-sidebar{ width: 300px;
    &__header{ background-color: $color4; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 100px; margin-left: 35px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
  }
  .filters{ position: absolute; top: 20px; right: 10px;
    .filter{ border: 1px solid $grisclair; font-size: 12px;
      &:last-of-type{ margin-left: 10px; }
    }
  }
  .content-area{ width: calc(100% - 300px); padding: 0 10px; margin-top: 0; position: relative;
    h1{ font-family: 'ClanFFBlack'; color: $color4; font-size: 25px; margin-bottom: 50px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color4; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .techs{ width: 100%; display: flex; flex-wrap: wrap; flex-direction: row; justify-content: flex-start;
      &__tech{ width: calc((100% - 30px) / 4); border: 1px solid $grisclair; height: 213px; margin-bottom: 10px; margin-right: 10px;
        &:nth-child(4n){ margin-right: 0; }
        &:last-of-type{ margin-right: 0; }
      }
      .tech{ display: flex; flex-wrap: wrap; flex-direction: row; position: relative;
        &__info-container{ width: 100%; display: flex; flex-wrap: wrap; flex-direction: column; align-items: center; justify-content: center; flex: 1; height: calc(100% - 75px) }
        &__stock-container{ display: flex; align-items: last baseline; }
        &__name{ font-size: 15px; font-family: 'ClanFFBlack'; color: $color4; margin-top: 30px; margin-bottom: 0; }
        &__link{ font-family: 'ClanPro'; font-size: 12px; color: $color3; }
        &__stock{ font-family: 'ClanPro'; color: $grisfonce; font-size: 14px;  margin-top: 0; }
        .stock{ margin: 0; margin-top: 10px; font-size: 13px;
          &__number{ color: $grisfonce; font-family: 'ClanFFBlack'; font-size: 15px; font-size: 13px; }
        }
        &__btns{ display: flex; flex-wrap: wrap; flex-direction: row; width: 100%; justify-content: flex-end; height: auto;

        }
        &__btn-container{ width: 110px; text-align: center;
          span{ color: $color2; font-family: 'ClanProBold'; font-size: 14px; }
          &:hover{ text-decoration: none; }
          img{ width: 25px; }
          .tech__btn{ background-color: $color2; display: flex; width: 100%; height: 50px; align-items: center; justify-content: center; }
        }
        // &__btn{ width: calc(100% / 3); text-align: center; height: 100%; color: white; padding: 10px 0;
        //   &--see{ background-color: $color2;
        //     img{ width: 30px;
        //       &.fleche{ width: 20px; margin-left: 5px; }
        //     }
        //   }
        //   .btn__number{ width: 20px; height: 20px; display: inline-block; border-radius: 50%; text-align: center; line-height: 22px; background-color: white; font-family: 'ClanFFBlack'; font-size: 11px; color: $rouge; margin-left: 7px; }
        // }
      }
    }
  }
  .filters{ display: flex; margin-bottom: 50px;
    .filter{ height: 35px; line-height: 35px;  border: 1px solid $color1; }
    input[type=text]{  width: auto; flex: 1; padding: 0 15px; }
  }

  @media screen and (max-width: 1450px){
    .content-area{
      .techs{
        &__tech{ width: calc((100% - 20px) / 3);
          &:nth-child(4n){ margin-right: 10px; }
          &:nth-child(3n){ margin-right: 0; }
        }
      }
    }
  }
  @media screen and (max-width: 1300px){
    .content-area{
      .techs{
        &__tech{ width: calc((100% - 10px) / 2);
          &:nth-child(3n){ margin-right: 10px; }
          &:nth-child(2n){ margin-right: 0; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/User/TechList.vue